import script from "./VipRightPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./VipRightPanel.vue?vue&type=script&setup=true&lang=js"

import "./VipRightPanel.vue?vue&type=style&index=0&id=3f7829ef&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7829ef"]])

export default __exports__